import React from 'react';
import { Icon } from './Icon.js';
export const IconRadioChecked = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m10,2C5.589,2,2,5.589,2,10s3.589,8,8,8,8-3.589,8-8S14.411,2,10,2Zm0,11c-1.657,0-3-1.343-3-3s1.343-3,3-3,3,1.343,3,3-1.343,3-3,3Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconRadioChecked.js.map